import { useEffect, useRef } from "react";
 
export function AskEndConversation ({handleEndConversation,handleEndCancelConversation}) {
   const bottomRef = useRef(null);
 
   useEffect(()=>{
       bottomRef.current?.scrollIntoView({ behavior: "smooth" });
   }, []);
 
   return <div class="text-center border border-primary rounded">       
           <div ref={bottomRef} class="card-body">
               <h5 class="card-title text-primary fw-bold">End Conversation</h5>
               <p class="card-text mt-4">Would you like to end this conversation and start over?</p>
               <button onClick={()=>handleEndConversation()} class="btn btn-outline-primary">End conversation</button>
               {/* <button onClick={()=>handleEndCancelConversation()} class="btn btn-outline-primary m-4">Cancel</button> */}
           </div>
           </div>
}